import { render, staticRenderFns } from "./CatalogComplexCard.vue?vue&type=template&id=7814c3f2&scoped=true"
import script from "./CatalogComplexCard.vue?vue&type=script&lang=js"
export * from "./CatalogComplexCard.vue?vue&type=script&lang=js"
import style0 from "./CatalogComplexCard.vue?vue&type=style&index=0&id=7814c3f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7814c3f2",
  null
  
)

export default component.exports